_ = require('lodash')

class RoundScoreChartCtrl
  constructor: (@$scope) ->
    @scoreData = _.pick @$scope.$parent.playersAnalysis.players[0],
      'rat_under_eagle'
      'rat_birdie'
      'rat_par'
      'rat_bogey'
      'rat_dbogey'
      'rat_over_tbogey'

RoundScoreChartCtrl.$inject = [
  '$scope'
]

module.exports = RoundScoreChartCtrl


// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/round-detail/round-score-chart/round-score-chart-controller.coffee